import { FC, useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  IDrawerBookingsProductionProps,
  IInjectedDrawerProps,
  noop,
} from "@ryde/shared";

import { BaseDrawer, DrawerHeader, FormFooter } from "../drawer";
import {
  ProductionClearCacheButton,
  ProductionViewLogsButton,
} from "../rich-logs";
import {
  BookingsProductionSteps,
  bookingsProductionStepsMap,
  DEFAULT_BOOKINGS_PRODUCTION_STEP,
} from "./bookings-production-steps";

export const DrawerBookingsProduction: FC<
  IDrawerBookingsProductionProps & IInjectedDrawerProps
> = ({ onCloseDrawer, drawerNumber, bookingsIds, direction, resolveFn }) => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState<BookingsProductionSteps>(
    DEFAULT_BOOKINGS_PRODUCTION_STEP,
  );

  const CurrentStepComponent = bookingsProductionStepsMap[currentStep];

  const handlersRef = useRef<{
    onCloseHandler: () => void;
    onSaveClick: (() => void) | undefined;
  }>({
    onCloseHandler: noop,
    onSaveClick: noop,
  });
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);
  const [cancelLabel, setCancelLabel] = useState(t("general.CANCEL"));
  const [saveLabel, setSaveLabel] = useState<string | undefined>(
    t("general.PRODUCE"),
  );

  const setHandlers = useCallback(
    ({
      onCloseHandler,
      onSaveClick,
    }: {
      onCloseHandler: () => void;
      onSaveClick?: () => void;
    }) => {
      handlersRef.current.onCloseHandler = onCloseHandler;
      handlersRef.current.onSaveClick = onSaveClick;
    },
    [],
  );

  return (
    <BaseDrawer
      onCloseDrawer={() => handlersRef.current.onCloseHandler()}
      drawerNumber={drawerNumber}
    >
      <DrawerHeader
        onCloseDrawer={() => handlersRef.current.onCloseHandler()}
        title={t("booking.bulk.newProduction")}
      />
      <CurrentStepComponent
        setHandlers={setHandlers}
        setCurrentStep={setCurrentStep}
        onCloseDrawer={onCloseDrawer}
        setIsSaveDisabled={setIsSaveDisabled}
        setCancelLabel={setCancelLabel}
        setSaveLabel={setSaveLabel}
        bookingsIds={bookingsIds}
        direction={direction}
        resolveFn={resolveFn}
      />
      <FormFooter
        onSaveClick={
          handlersRef.current.onSaveClick
            ? () => handlersRef.current.onSaveClick?.()
            : undefined
        }
        onCancelClick={() => handlersRef.current.onCloseHandler()}
        saveLabel={saveLabel}
        isSaveDisabled={isSaveDisabled}
        cancelLabel={cancelLabel}
      >
        <ProductionViewLogsButton />
        <ProductionClearCacheButton />
      </FormFooter>
    </BaseDrawer>
  );
};
